import React from "react";
import ObjectiveImage from "../../resources/objective_image.png";

const Objective = () => {
    return (
    <div className="page__section" id="objective">
        <p className="title">Obiettivo</p>
        <hr></hr>
        <div className='objective__content'>
        <img className='objective__image' src={ObjectiveImage}></img>
        <div className='objective__text'>
            <p className='objective__text__cell'>
                Con l'avvicinamento dell'anno prefissato e viste le stringenti regole riguardo all'energia dell'<a href='https://www.agenziacoesione.gov.it/comunicazione/agenda-2030-per-lo-sviluppo-sostenibile/' target='_blank'><u>Agenda 2030</u></a>,
                abbiamo voluto cercare una soluzione per risparmiare energia in maniera semplice e adatta 
                a qualsiasi realtà aziendale.
            </p>
        </div>
        </div>
    </div>
    );
};


export default Objective;